var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgA4ElectricalInstaller(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M61 43v18h-6V36.47A6.87 6.87 0 0161 43zm-28 5h10V36H33v12zm13 3H30V36h-6v25h28V36h-6v15zm-2.39-20.65a9 9 0 10-11.182-14.107A9 9 0 0043.61 30.35zM15 43v18h6V36.47A6.87 6.87 0 0015 43z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/A4_Electrical_installer.85fd9df3.svg";
export { SvgA4ElectricalInstaller as ReactComponent };